import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardPagesRoutingModule } from './dashboard-pages-routing.module';
import { RouterModule } from '@angular/router';


import { BlankComponent } from '@pages/blank/blank.component';
import { ProfileComponent } from '@pages/profile/profile.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { MainMenuComponent } from '@pages/main-menu/main-menu.component';
import { SubMenuComponent } from '@pages/main-menu/sub-menu/sub-menu.component';
import { ActivityTabComponent } from '@pages/profile/activity-tab/activity-tab.component';
import { TimelineTabComponent } from '@pages/profile/timeline-tab/timeline-tab.component';
import { SettingsTabComponent } from '@pages/profile/settings-tab/settings-tab.component';
import { PostComponent } from '@pages/profile/post/post.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DashboardComponentsModule } from '@components/dashboard-components.module';

@NgModule({
  declarations: [
    BlankComponent,
    ProfileComponent,
    DashboardComponent,
    MainMenuComponent,
    SubMenuComponent,
    ActivityTabComponent,
    TimelineTabComponent,
    SettingsTabComponent,
    PostComponent,
  ],
  exports: [
    BlankComponent,
    ProfileComponent,
    DashboardComponent,
    MainMenuComponent,
    SubMenuComponent,
    ActivityTabComponent,
    TimelineTabComponent,
    SettingsTabComponent,
    PostComponent,
  ],
  imports: [
    DashboardComponentsModule,
    RouterModule,
    CommonModule,
    DashboardPagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
  ]
})
export class DashboardPagesModule { }
